module.exports = __webpack_public_path__ + "static/media/volume.44c077f2.svg";